import Localization from './Localization';
const NSLocalizedString: (key: string, comment: string, defaultValue?: string) => string = Localization.getLocalizedString;
export default NSLocalizedString;
